import BoxIcon from '@shared/components/BoxIcon';
import { formatPhoneNumber } from '@shared/entity';
import AppTheme from '@libs/mui/AppTheme';
import { Stack, Typography } from '@mui/material';
import { ClientWithVisitsWithVisitServices } from '../entity';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { PHONE_PREFIXES } from '@shared/components/phone-prefix-autocomplete';

const getFlag = (prefix?: string | null): string => {
  if (!prefix) return '';
  return PHONE_PREFIXES.find(p => p.dialCode === prefix)?.flag ?? '';
};

export const ClientContactInfo = (props: {
  clientData: ClientWithVisitsWithVisitServices;
  onEdit: () => void;
}) => {
  const { clientData, onEdit } = props;
  const flag = getFlag(clientData.phonePrefix);
  const prefix = clientData.phonePrefix ?? '';
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <AccountBoxIcon fontSize="large" color="primary" />
      <Stack>
        <Typography variant="h6">
          {[clientData.firstName, clientData.lastName].filter(Boolean).join(' ')}
        </Typography>
        <Typography variant="body2">
          {flag && <span style={{ marginRight: 4 }}>{flag}</span>}
          {prefix && <span style={{ marginRight: 4, opacity: 0.6 }}>{prefix}</span>}
          {formatPhoneNumber(clientData.phone)}
        </Typography>
      </Stack>
      <BoxIcon
        sx={{ background: `${AppTheme.palette.primary.light}` }}
        onClick={onEdit}
        icon={<EditOutlinedIcon color="secondary" />}
      />
    </Stack>
  );
};
